<template>
  <ym-block class="icon-block-component"
            :class="[
              { 'is-show-control': showControl },
            ]"
            :title="block.title"
            size="small"
  >
    <template #icon>
      <ym-icon class="icon-block-icon"
               :name="block.icon"
      />
    </template>

    <slot></slot>

    <div v-if="showControl"
         class="icon-block-control"
    >
      <ym-button v-if="showMore"
                 class="icon-block-control-btn"
                 type="primary"
                 size="medium"
                 plain
                 @click="handleGetMore"
      >
        查看更多{{ block.title }}<span v-if="block.count && block.count > 0"
                                   class="icon-block-control-btn-highlight"
      >({{ block.count }})</span>
        <ym-icon class="icon-block-control-icon"
                 name="down"
        />
      </ym-button>
      <ym-button v-if="showHideMore"
                 class="icon-block-control-btn"
                 type="primary"
                 size="medium"
                 plain
                 @click="handleHideMore"
      >
        收起
        <ym-icon class="icon-block-control-icon is-up"
                 name="down"
        />
      </ym-button>
    </div>
  </ym-block>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import Block from '@/components/Block';

  export default {
    name: 'IconBlock',
    components: {
      'ym-button': Button,
      'ym-block': Block,
    },
    props: {
      block: {
        type: Object,
        required: true,
      },
      showMore: Boolean,
      showHide: Boolean,
    },
    computed: {
      showHideMore() {
        const { showMore, showHide } = this;
        return !showMore && showHide;
      },
      showControl() {
        return this.showMore || this.showHideMore;
      },
    },
    methods: {
      handleGetMore() {
        this.$emit('show-more');
      },
      handleHideMore() {
        this.$emit('hide-more');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .icon-block {
    &-component {
      margin-top: 0;
      position: relative;
    }

    &-icon {
      color: @color-gray-light;
      font-size: 32px;
      flex-shrink: 0;
      margin-top: -4px;
      margin-right: @size-extra-small;
    }

    &-control {
      margin-top: -@size-base;
      padding: @size-extra-small @size-base;

      &-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
      }

      &-icon {
        font-size: 30px;
        flex-shrink: 0;
        margin-left: @size-small;

        &.is-up {
          transform: rotate(180deg);
        }
      }
    }
  }
</style>
